import { Box, Grid, Typography } from '@mui/material';

export function DetailField({ label, value, monospace = false }) {
  return (
    <Grid item xs={12} sm={6}>
      <Box
        sx={{
          p: { xs: 1.5, sm: 2 },
          bgcolor: 'action.hover',
          borderRadius: 1,
          height: '100%',
        }}
      >
        <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            wordBreak: monospace ? 'break-all' : 'break-word',
            fontFamily: monospace ? 'monospace' : 'inherit',
          }}
        >
          {value}
        </Typography>
      </Box>
    </Grid>
  );
}
